import defaultSettings from 'source/default_settings';

import SettingsModel from './base_settings_model';

const settingsModel = new SettingsModel(defaultSettings, {
    appName: 'wgni',
});

export default settingsModel;
